import { render } from "./TrainingsView.vue?vue&type=template&id=37bf9efd&scoped=true"
import script from "./TrainingsView.vue?vue&type=script&lang=js"
export * from "./TrainingsView.vue?vue&type=script&lang=js"

import "./TrainingsView.vue?vue&type=style&index=0&id=37bf9efd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bf9efd"]])

export default __exports__